import React, { useState } from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { renderComponent } from '../../../helpers/RenderComponent';
import { getTabclixCode } from '../../../helpers/embed-code';
import Button from '../button/Button';
import { fetchAuth, postForms } from '../../../api/tabclixContentApi';
import FormCss from "./fom.module.scss";
import { useNotification } from '../../messages/MessageProvider';
import message from '../../messages/message.json'
import MainMessage from '../../messages/MainMessage';

function Form(props) {
  
  const [sending, setSending] = useState(false);

  const dispatch = useNotification();

  const formMethods = useForm();
  const { handleSubmit, reset } = formMethods;  // Destructure reset from formMethods

  const onSubmit = async (data) => {

    props.forms.map((child, index) => {
      if(child.type == "text-title"){
        console.log(child.label);
        return data['form_title'] = child.label;
      }
  });

    try {
      
      setSending(true);
      let code = getTabclixCode();
      data['user_id'] = code; 
      data['connected_form_id'] = props.connected_form_id;
      // data['form_title'] = props.forms['']
      
      const authToken = await fetchAuth();

      await postForms(authToken, data);
      
      dispatch(message.Messages.submissionSuccess)
      
      // Reset the form after submission
      reset();
      
    } catch (error) {
      dispatch(message.Messages.submissionError)
    } finally {
      setSending(false);
    }
  };

  return (
    <FormProvider {...formMethods}>

      <form onSubmit={handleSubmit(onSubmit)} disabled={sending}>
        {props.forms.map((child, index) => (
          <div className="Row" key={index}>
            {child.type === "button" ? <Button {...child} state={sending} /> : renderComponent(child)}
          </div>
        ))}
      </form>

    </FormProvider>
  );
}

export default Form;